import {
    ActionFunction,
} from "react-router-dom";
import { axiosApi } from "../../interceptors/axios";
import { toast } from "react-toastify";


export const userPrefencesAction: ActionFunction = async ({ request, params }) => {
    const formData = await request.formData();
    return toast.promise(axiosApi.post("/api/userPreferences/create-for-user-range", { userPreferenceCreateDtoList: JSON.parse(formData.get("preferences") as any) }),
        { pending: "Tercihler kayıt ediliyor.", error: "Başarısız",success:"Başarılı" })

}